<template>
  <div class="activities">
    <div v-if="!activities.length" class="activities__empty">
      <div class="activities__empty-icon">
        <img src="@/assets/img/communication.svg" alt="">
      </div>
      <div class="activities__empty-body">
        <div class="activities__empty-title">CLIENT HASN'T BEEN ADDED TO THE CLIMB / SAFARI</div>
        <div class="activities__empty-text">
          Add client to
          <router-link :to="{name: 'climbing-groups'}" class="activities__empty-link">climb</router-link>
          / <router-link :to="{name: 'safari-groups'}" class="activities__empty-link">safari</router-link>
        </div>
      </div>
    </div>
    <div v-if="activities.length" class="activities__list">
      <div v-for="item in activities" :key="item.id" class="activities__item">
        <div class="activities__top">
          <div v-if="item.activity === 'climbing'" class="activities__title">
            Climbing {{ item.route.mountain.name }} <router-link :to="{ name: 'climbing-groups-detail-clients', params: { id: item.id } }">({{ item.name }} - {{ item.id }})</router-link>
          </div>
          <div v-else class="activities__title">
            Safari <router-link :to="{ name: 'safari-groups-detail-clients', params: { id: item.id } }">({{ item.name }} - {{ item.id }})</router-link>
          </div>
          <div class="activities__info">
            <span v-if="item.activity === 'climbing'">Route: <b>{{ item.route.name }}</b></span>
            <span v-if="item.activity === 'climbing'">Duration: <b>{{ item.route.duration }}</b></span>
            <span v-else>Duration: <b>{{ item.duration }}</b></span>
            <span>Start: <b>{{ dateFormatting(item.tour_start) }}</b></span>
            <span>Finish: <b>{{ dateFormatting(item.tour_end) }}</b></span>
          </div>
        </div>
        <template v-if="item.snack_bar">
          <p
            v-if="!item.orders_available && item.snack_bar.completed && item.snack_bar.outstanding_amount <= 0"
            class="activities__info-text"
          >
            Client's order is already being prepared, it's impossible to make changes now. Contact operation manager for assistance.
          </p>
          <p
            v-if="!item.orders_available && item.snack_bar.completed && item.snack_bar.outstanding_amount > 0"
            class="activities__info-text"
          >
            We will start preparing clients order after the full payment. Ask client open the shopping cart and proceed to make the payment.
          </p>
        </template>
        <div v-if="item.activity === 'climbing'" class="activities__row">
          <div class="activities__name">
            <img src="@/assets/img/checklist-icon.svg" alt="">
            <span>Equipment rentals</span>
            <img v-if="item.checklist.completed" src="@/assets/img/approved-icon.svg" alt="Approve">
            <img v-else src="@/assets/img/clock-snacks.svg" alt="Clock">
            <a
              v-if="is_sales_general_manager"
              :href="`${family_url}${client_hash}/rentals/${item.id}`"
              target="_blank"
              class="activities__link"
            ></a>
            <button
              v-if="!is_sales_manager"
              @click="onExport(item.id)"
              class="activities__link activities__link--print"
            ></button>
          </div>
        </div>
        <div v-else class="activities__row">
          <div class="activities__name">
            <img src="@/assets/img/snacks-icon.svg" alt="Snacks">
            <span>Snack bar</span>
            <img v-if="item.snack_bar?.completed" src="@/assets/img/approved-icon.svg" alt="Approve">
            <img v-else src="@/assets/img/clock-snacks.svg" alt="Clock">
            <a
              v-if="is_sales_general_manager"
              :href="`${family_url}${client_hash}/snacks/${item.hash}`"
              target="_blank"
              class="activities__link"
            ></a>
          </div>
          <div class="activities__right">
            <div class="activities__edited">
              <p v-if="item.snack_bar?.completed"><span>Order amount:</span> <span>{{ item.snack_bar.order_amount }}$</span></p>
              <p v-if="item.snack_bar?.completed && item.snack_bar.outstanding_amount">
                <span>Amount to pay:</span> <span>{{ item.snack_bar.outstanding_amount }}$</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClimbingGroupChecklistExport } from '@/http'
import {format, parseISO} from 'date-fns'

export default {
  name: 'Activities',
  props: {
    activities: {
      type: Array,
      required: true
    },
    client_hash: { String }
  },
  data() {
    return {
      family_url: process.env.VUE_APP_FAMILY,
      export_loading: false,
    }
  },
  computed: {
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager') || this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    }
  },
  methods: {
    dateFormatting(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy')
    },
    onExport(group_id) {
      getClimbingGroupChecklistExport(group_id, this.$route.params.id)
        .then(response => {
          window.open(response.data)
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.activities__photo
  display: inline-block
  width: 24px
  height: 24px
  border-radius: 50%
  border: 2px solid #fff
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15)
  overflow: hidden

  img
    width: 100%
    height: 100%
    object-fit: cover

.activities__empty
  display: flex
  align-items: center
  gap: 10px 20px
  margin-bottom: 20px
  padding: 24px
  border: 1px solid #eaeaea
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff

.activities__empty-icon
  line-height: 0

.activities__empty-title
  margin-bottom: 6px
  color: #181818
  font-weight: 500
  text-transform: uppercase

.activities__empty-text
  display: flex
  gap: 5px
  color: #a0a0a0

.activities__empty-link
  display: flex
  flex-direction: column
  width: max-content
  color: #a0a0a0
  transition: color 0.3s

  &:after
    content: ''
    display: block
    height: 2px
    border-radius: 3px
    background-color: #aae182
    transform: translateY(-1px)
    transition: opacity 0.3s

  &:hover
    &:after
      opacity: 0

.activities__list
  margin-bottom: 40px

  &:last-child
    margin-bottom: 0

.activities__item
  margin-bottom: 40px

  &:last-child
    margin-bottom: 0

.activities__top
  display: flex
  align-items: center
  justify-content: space-between
  margin-bottom: 15px

.activities__title
  color: #181818
  font-size: 15px
  font-weight: 600

  a
    display: inline-flex
    flex-direction: column
    width: max-content
    color: $color-text-base
    transition: color 0.3s

    &:after
      content: ''
      display: block
      height: 2px
      border-radius: 3px
      background-color: #aae182
      transform: translateY(-1px)
      transition: opacity 0.3s

    &:hover
      &:after
        opacity: 0

.activities__info
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 10px 30px

  span
    color: #5e5e5e
    font-size: 13px
    font-weight: 500

    b
      color: #181818
      font-weight: 500

.activities__row
  display: flex
  align-items: center
  justify-content: space-between
  gap: 10px
  margin-bottom: 10px
  padding: 9px 12px
  border: 1px solid #eaeaea
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff

  &:last-child
    margin-bottom: 0

.activities__name
  flex-shrink: 0
  display: flex
  align-items: center
  gap: 10px
  line-height: 0

  span
    color: #181818
    font-weight: 500

.activities__right
  display: flex
  align-items: center
  gap: 10px 30px

.activities__edited
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 10px 25px

  p
    color: #959595
    font-size: 13px

    span:last-child
      color: #181818

.activities__center
  display: flex
  align-items: center
  gap: 6px

.activities__control-list
  display: flex
  align-items: center
  gap: 10px

  button
    border-radius: 9px
    box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.15)
    line-height: 0
    transition: transform 0.3s

    &:hover
      transform: translateY(-1px)

.activities__not-found
  color: $color-error

.activities__controls
  display: flex
  align-items: center
  gap: 10px

.activities__link
  width: 25px
  height: 25px
  border-radius: 9px
  box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.15)
  background-image: url("~@/assets/img/snacks-link.svg")
  transition: opacity 0.3s

  &:hover
    opacity: 0.8

.activities__link--print
  width: 25px
  height: 25px
  border-radius: 9px
  box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.15)
  background-image: url("~@/assets/img/print-table-icon.svg")
  transition: opacity 0.3s

  &:hover
    opacity: 0.8

.activities__info-text
  margin-bottom: 15px
  font-size: 13px
  color: #5e5e5e
</style>
